import { EventTypeConstants } from "../_constants";
import { EventTypesService } from "../_services";

export const EventTypesActions = {
  getGlobalEventTypes,
};

function getGlobalEventTypes() {
  return (dispatch) => {
    dispatch(request());

    return EventTypesService.getGlobalEventTypes().then(
      (eventTypes) => {
        dispatch(success(eventTypes));
        return eventTypes;
      },
      (error) => {
        console.log("[CHRONOS] Error: Fetching EventTypes", error.toString());
        dispatch(failure(error.toString()));
      }
    );
  };

  function request() {
    return {
      type: EventTypeConstants.FETCH_EVENT_TYPES_REQUEST,
      params: "GLOBAL",
    };
  }

  function success(payload) {
    return {
      type: EventTypeConstants.FETCH_EVENT_TYPES_SUCCESS,
      payload,
    };
  }

  function failure(error) {
    return {
      type: EventTypeConstants.FETCH_EVENT_TYPES_FAILURE,
      error,
    };
  }
}
